import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Login',
		component: () => import('../views/login.vue')
	},
	{
		path: '/admin',
		name: 'Admin',
		component: () => import('../views/admin/layout.vue'),
		children: [
			{
				path: '/',
				name: 'Dashboard',
				component: () => import('../views/admin/dashboard.vue')
			},
			{
				path: 'cards',
				name: 'Cards',
				component: () => import('../views/admin/masters/cards.vue')
			},
			{
				path: 'Events',
				name: 'eventmaster',
				component: () => import('../views/admin/masters/EventMaster.vue')
			},
			{
				path: 'EditEvents',
				name: 'editevent',
				component: () => import('../views/admin/masters/EventEdit.vue')
			},
			{
				path: 'stand',
				name: 'Stand',
				component: () => import('../views/admin/masters/stand.vue')
			},



			{
				path: 'city',
				name: 'City',
				component: () => import('../views/admin/masters/city.vue')
			},
			{
				path: 'companyjobtypemap',
				name: 'Company job type map',
				component: () => import('../views/admin/masters/companyjobtypemap.vue')
			},


			{
				path: 'EventVenueStandMap',
				name: 'EventVenueStandMap',
				component: () => import('../views/admin/masters/EventVenueStandMap.vue')
			},
			{
				path: 'status',
				name: 'Status',
				component: () => import('../views/admin/masters/status.vue')
			},

			{
				path: 'media',
				name: 'Media',
				component: () => import('../views/admin/masters/Media.vue')
			},

			{
				path: 'mediajob',
				name: 'MediaJob',
				component: () => import('../views/admin/masters/MediaJob.vue')
			},



			{
				path: 'mediacategory',
				name: 'MediaCategory',
				component: () => import('../views/admin/masters/MediaCategory.vue')
			},

			{
				path: 'cardsetup',
				name: 'cardsetup',
				component: () => import('../views/admin/masters/cardsetup.vue')
			},

			{
				path: 'idproofsetup',
				name: 'idproofsetup',
				component: () => import('../views/admin/masters/Idproofsetup.vue')
			},

			{
				path: 'setting',
				name: 'setting',
				component: () => import('../views/admin/masters/setting.vue')
			},

			{
				path: 'venues',
				name: 'Venues',
				component: () => import('../views/admin/masters/venues.vue')
			},
			{
				path: 'users',
				name: 'users',
				component: () => import('../views/admin/masters/userCreate.vue')
			},
			{
				path: 'jobzone',
				name: 'jobzone',
				component: () => import('../views/admin/masters/JobZone.vue')
			},

			{
				path: 'jobAdmin',
				name: 'jobAdmin',
				component: () => import('../views/admin/masters/JobAdminMap.vue')
			},

			{
				path: 'mediajobstandmap',
				name: 'Mediajobstandmap',
				component: () => import('../views/admin/masters/MediaJobstandmap.vue')
			}



		]
	},
	{
		path: '/app',
		name: 'App',
		component: () => import('../views/user/layout.vue'),
		children: [
			{
				path: '/',
				name: 'Dashboard',
				component: () => import('../views/user/dashboard.vue')
			},
			{
				path: 'newapplication',
				name: 'Application',
				component: () => import('../views/user/newapplication.vue')
			},
			{
				path: 'reports',
				name: 'Reports',
				component: () => import('../views/user/reports.vue')
			}
		]
	},
	{
		path: '*',
		name: 'NoFound',
		component: () => import('../views/notfound.vue'),
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
